import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { acceptedPrivateRoles } from './routesObj'

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      rest.isLoggedIn && acceptedPrivateRoles.includes(rest.role) ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/' }} />
      )
    }
  />
);

export default PrivateRoute;